import { takeEvery, call, put, select, race, delay } from 'redux-saga/effects'
import { auth } from '../../lib/requests/authRequest'
import { delays } from '../../lib/constants'
import { getCurrentLang, getDicionary } from '../selectors'

export function* worker({ login, password, history }) {
  try {
    const currentLang = yield select(getCurrentLang)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(auth, login, password, currentLang),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({ type: 'SET_TOKEN', payload: result.data.data.token, history })
      localStorage.setItem('sovToken', JSON.stringify(result.data.data.token))
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
    }
  } catch (e) {
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
  }
}

export default function* setAuthorization() {
  yield takeEvery('SET_AUTHORIZATION', worker)
}
